import { all, fork } from 'redux-saga/effects';
import siteComponentSagas from 'yoda-site-components/lib/sagas';
import watchAddToCartInterstitialSaga from 'yoda-checkout-components/lib/sagas/AddToCartInterstitialSaga';
import watchCarePlanWarrantySaga from 'yoda-checkout-components/lib/sagas/CarePlanWarrantySaga';
import watchcartItemUpdateSaga from 'yoda-checkout-components/lib/sagas/CartItemUpdateSaga';
import watchRemoveSavedItem from 'yoda-checkout-components/lib/sagas/RemoveSavedItemSaga';
import { watchMessageContent } from 'yoda-checkout-components/lib/sagas/MessageContentSaga';
import shippingProtectionSaga from 'yoda-checkout-components/lib/sagas/ShippingProtectionSaga';
import watchProductDetailsSaga from 'yoda-site-components/lib/sagas/ProductDetailsSaga';
import watchPlccDynamicBannerSaga from 'yoda-site-components/lib/sagas/PlccDynamicBannerSaga';
import watchProductPricingSaga from 'yoda-site-components/lib/sagas/ProductPricingSaga';
import watchInventorySaga from 'yoda-site-components/lib/sagas/ProductInventorySaga';
import watchMyAlertsSaga from 'yoda-site-components/lib/sagas/MyAlertsSaga';
import watchBOPISMessageRequest from 'yoda-site-components/lib/sagas/BOPISMessageSaga';
import watchListsRequest from 'yoda-site-components/lib/sagas/ListsSaga';
import watchCouponDetailsRequest from 'yoda-site-components/lib/sagas/CouponDetailsSaga';
import watchSelectStore from 'yoda-site-components/lib/sagas/SelectStoreSaga';
import watchMTLToolTipSaga from 'yoda-site-components/lib/sagas/SavedListToolTip';

import watchSYFQuickScreenSaga from 'yoda-account-components/lib/sagas/SYFQuickScreenSaga';
import watchIrisS1PromotionalBannerSaga from './IrisS1PromotionalBannerSaga';
import watchProductSpecificationsSaga from './ProductSpecificationsSaga';
import watchAddToCartSaga from './AddToCartSaga';
import watchProductContentSaga from './ProductContentSaga';
import watchCustomOptionsSaga from './CustomOptionsSaga';
import watchPDPBreadcrumbsSaga from './PDPBreadcrumbsSaga';
import watchDeliveryZipcodeSaga from './DeliveryZipcodeSaga';
import watchUpdateCartSaga from './UpdateCartSaga';
import watchVisitStoreToPurchaseSaga from './VisitStoreToPurchaseSaga';
import watchUrgencyMessagingSaga from './UrgencyMessagingSaga';
import watchProductCollectionPricingSaga from './ProductCollectionPricingSaga';
import watchPDPPLASToreSaga from './PLAStoreSaga';
import watchCreditCardBannerSaga from './CreditCardBannerSaga';
import watchCMCreditCardBannerSaga from './CMCreditCardBannerSaga';

const siteComponentSagaList = Object.values(siteComponentSagas.injectedSagas);
const productSagas = [
    /**
     * To get a product related specifications
     * src/components/ProductSpecifications/ProductSpecifications.jsx
     */
    watchProductSpecificationsSaga,
    /**
     * To add item to cart
     * src/components/AddToCart/withAddToCartHOC.jsx
     * src/components/Bundle/BundleAddToCart/BundleAddToCart.jsx
     */
    watchAddToCartSaga,
    /**
     * To get a product General information and shipping & return details
     * src/components/GeneralInformation/GeneralInformation.jsx
     * src/components/ShippingAndReturns/ShippingAndReturns.jsx
     */
    watchProductContentSaga,
    /**
     * To get a product custom options details
     * yoda-site-components/src/components/CustomOptions/CustomOptions.jsx
     */
    watchCustomOptionsSaga,
    /**
     * To get a breadcrumb details from search api
     * src/components/PDPBreadcrumbs/PDPBreadcrumbs.jsx
     */
    watchPDPBreadcrumbsSaga,
    /**
     * To get delivery zipcode from lat lang
     * src/containers/Pages/PDP/PDP.jsx
     */
    watchDeliveryZipcodeSaga,

    /**
     * To update the item to cart request
     * src/components/AddToCart/withAddToCartHOC.jsx
     */
    watchUpdateCartSaga,
    /**
     * To get a add to cart confirmation
     * src/components/ProductCollection/ProductCollection.jsx
     * yoda-mini-pdp/src/components/MiniPDPInterstitial/MiniPDPInterstitial.jsx
     * yoda-checkout-components/src/components/AddToCartInterstitial/AddToCartInterstitial.jsx
     */
    watchAddToCartInterstitialSaga,
    /**
     * To get a Learn more link content from IRIS.
     * src/components/ProductCollection/ProductCollection.jsx
     * yoda-mini-pdp/src/components/MiniPDPInterstitial/MiniPDPInterstitial.jsx
     * yoda-checkout-components/src/components/AddToCartInterstitial/AddToCartInterstitial.jsx
     */
    watchCarePlanWarrantySaga,

    /**
     * To get cart update details
     * yoda-checkout-components/src/components/AddToCartInterstitial/components/InterstitialWrapper/InterstitialWrapper.jsx
     * yoda-checkout-components/src/components/EditCartSilverItemCTA/EditCartSilverItemCTA.jsx
     */
    watchcartItemUpdateSaga,
    /**
     * Product availability Stores get with this request.
     * src/components/VisitStoreToPurchase/VisitStoreToPurchase.jsx
     */
    watchVisitStoreToPurchaseSaga,
    /**
     * To request for displaying urgency messages on PDP
     * src/components/UrgencyMessaging/UrgencyMessaging.jsx
     */
    watchUrgencyMessagingSaga,
    /**
     * To fetch all product pricing
     * src/components/ProductCollection/ProductCollection.jsx
     */
    watchProductCollectionPricingSaga,
    /**
     * To request all the PDP page main details like product options, primary images, alt images etc.
     * src/containers/Pages/PDP/PDP.jsx
     * yoda-mini-pdp/src/components/MiniPDPInterstitial/MiniPDPInterstitial.jsx
     */
    watchProductDetailsSaga,
    /**
     * To get product pricing details
     * yoda-site-components/lib/components/ProductPricing/ProductPricing.jsx
     */
    watchIrisS1PromotionalBannerSaga,
    watchProductPricingSaga,
    /**
     * To fetch product inventory from /inventory/pricing api
     * src/components/Bundle/BundleChildLevel/BundleCollectionDetails.jsx
     * src/components/MiniPDPInterstitial/MiniPDPInterstitial.jsx
     * yoda-site-components/src/components/ProductOptions/ProductOptions.jsx
     */
    watchInventorySaga,
    /**
     * To display alert popup to subscribe request
     * yoda-site-components/src/components/MyAlertsSignup/MyAlertsSignup.jsx
     * yoda-site-components/src/components/StockAlertSignUpModal/StockAlertSignUpModal.jsx
     * yoda-site-components/lib/components/StockAlertSignUpModal/StockAlertSignUpModalConnect.jsx
     */
    watchMyAlertsSaga,
    /**
     * To display BOPIS message dynamically from the api instead of hard code message
     * yoda-site-components/src/components/ProductPricing/ProductPricing.jsx
     */
    watchBOPISMessageRequest,
    /**
     * Saved items remove request
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     */
    watchRemoveSavedItem,
    watchMessageContent,
    /**
     * PDP/Listing - add to list
     * yoda-microsite-listing/src/containers/Pages/Lists/ListDetailsPanel/ListDetailsPanel.jsx
     * yoda-microsite-pdp/src/components/AddToList/AddToList.jsx
     */
    watchListsRequest,
    /**
     * PDP/mini-PDP - FPAC
     * yoda-microsite-pdp/src/components/Bundle/BundlePricing/DeprecatedComponents/FPAC.jsx
     * yoda-microsite-pdp/src/components/StickyHeader/StickyHeader.jsx
     * yoda-microsite-pdp/src/containers/Pages/PDP/Common/Common.jsx
     * yoda-microsite-listing/src/containers/Pages/Lists/ListDetailsPanel/ListDetailsPanel.jsx
     * yoda-microsite-coupon/src/helper/MiniPDPHelper.jsx
     * yoda-microsite-pdp/src/containers/Pages/PDP/PDP.jsx
     * yoda-microsite-marketing/src/helper/renderMiniPDP.jsx
     * yoda-microsite-gallery/src/containers/Pages/Gallery/GalleryDesktop.jsx
     */
    watchCouponDetailsRequest,
    /**
     * selected store
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     */
    watchSelectStore,
    /**
     * add to my list
     * yoda-microsite-listing/src/components/Lists/Move/Move.jsx
     * yoda-microsite-pdp/src/components/AddToList/AddToList.jsx
     */
    watchMTLToolTipSaga,

    watchPDPPLASToreSaga,
    /* src/components/CreditCardBanner/CreditCardBanner.jsxsrc/components/CreditCardBanner/CreditCardBanner.jsx */
    watchCreditCardBannerSaga,
    watchCMCreditCardBannerSaga,
    /**
     * This to get quickscreebanner from /yoda-account-components/lib/components/SYFQuickScreen/QuickScreenLazy.js and render on src/components/Common.jsx
     */
    watchSYFQuickScreenSaga,
    /**
     *  This is to get see offer details CMS content in quickscreen, which is there in common response of plccdynamicbanner content API call
     */
    watchPlccDynamicBannerSaga,
    shippingProtectionSaga,
    ...siteComponentSagaList,
];

const injectedSagas = {};
for (const saga of productSagas) { // eslint-disable-line
    // 1. Check that every saga has a name
    if (!saga.sagaName) {
        throw new Error(
            `Every saga has to have sagaName property. For debug purposes: ${saga.toString()}`
        );
    }

    // 2. Check that we have only unique sagas (one could be from components, another the same one from shared)
    if (injectedSagas[saga.sagaName]) {
        throw new Error(
            `That saga ${saga.sagaName} was already registered. Only 1 instance for particular name is allowed`
        );
    }
    injectedSagas[saga.sagaName] = saga;
}

const productRootSaga = function* productRootSaga() {
    yield all(Object.values(injectedSagas).map((saga) => fork(saga)));
};

productRootSaga.injectedSagas = injectedSagas;

export default productRootSaga;
